<template>
  <v-container
    id="painelfluxocaixa2"
    fluid
    tag="section"
    class="px-3 pt-0"
    style="margin-top: 1rem"
  >
    <div>
      <v-row>
        <v-col
          cols="12"
          class="container"
        >
          <dashboard-filtro-datas
            :primeiro="enablePrimeiroDia"
            :ultimo="enableUltimoDia"
            :empresas="enableEmpresa"
            :url="link"
          />
          <v-row v-if="enableBtnPrint">
            <v-col
              cols="12"
              sm="12"
              md="12"
              lg="12"
              class="text-left"
            >
              <v-btn
                class="col-6 col-sm-6 col-md-2 col-lg-2"
                small
                :color="corPrimaria"
                dark
                :loading="loadingPrint"
                @click="imprimir()"
              >
                <v-icon>
                  mdi-printer
                </v-icon>
                Imprimir
              </v-btn>
            </v-col>
          </v-row>
          <v-row id="saldoBancario">
            <v-col
              cols="12"
              sm="12"
              md="12"
              lg="5"
            >
              <v-container>
                <v-card
                  id="cardDashbord"
                  class="mx-auto"
                  outlined
                >
                  <div class="card-header-dashbord">
                    <v-row>
                      <v-col
                        cols="12"
                        sm="10"
                        md="10"
                        lg="10"
                        class="d-flex flex-wrap"
                      >
                        Qual seu saldo bancário disponível?
                      </v-col>
                      <v-col
                        cols="12"
                        sm="2"
                        md="2"
                        lg="2"
                        class="d-flex justify-end"
                      >
                        <v-tooltip
                          top
                          max-width="400"
                          width="400"
                        >
                          <template
                            v-slot:activator="{ on, attrs }"
                          >
                            <v-icon
                              id="iconInformationFatxMetaComercial4"
                              class="text-left"
                              v-bind="attrs"
                              v-on="on"
                              @mouseover="enableTexto('195')"
                            >
                              mdi-information-outline
                            </v-icon>
                          </template>
                          <div
                            v-if="!carregandoTooltip"
                            v-html="textoOrientacao"
                          />
                        </v-tooltip>
                      </v-col>
                    </v-row>
                  </div>
                  <v-card-actions>
                    <v-row>
                      <v-col
                        id="saldoTotalId"
                        cols="12"
                        sm="12"
                        md="12"
                        lg="12"
                        class="text-right"
                      >
                        <h1
                          v-if="enableTextoSaldo"
                          id="textoSaldo"
                          :style="styleSaldoBancario"
                          class="text-center"
                        >
                          Saldo Disponível
                        </h1>
                        <show-saldo-total-fluxo-caixa />
                      </v-col>
                      <v-col
                        cols="12"
                        sm="12"
                        md="12"
                        lg="12"
                      >
                        <show-saldo-contas-fluxo-caixa id="tabelaContaId" />
                      </v-col>
                    </v-row>
                  </v-card-actions>
                </v-card>
              </v-container>
            </v-col>
            <v-col
              cols="12"
              sm="12"
              md="12"
              lg="7"
            >
              <v-row id="projecaoFinanceira">
                <v-col
                  cols="12"
                  sm="12"
                  md="12"
                  lg="12"
                >
                  <v-container>
                    <dashoard-card-view
                      :exibir-texto-titulo="true"
                      :code-information="'196'"
                      :text="'Qual a projeção financeira para os próximos 35 dias?'"
                      :texto-information="textoProjecaoFinanceira"
                      :style-object="styleSaldoBancario"
                      :componente-grafico="true"
                      :grafico-id="'myChart17'"
                      :dados-grafico="chartFluxoCaixa"
                      :titulo-id="'myChart17'"
                      :exibir-legenda="true"
                      :padding="dynamicPaddingFluxoVenda2"
                      :loading="loadingGraficoProjecaoFinanceira"
                    />
                  </v-container>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row id="movimentacaoFinanceiraValores">
            <v-col
              cols="12"
              sm="12"
              md="12"
              lg="12"
            >
              <v-card
                id="cardDashbord"
                class="mx-auto"
                outlined
              >
                <div class="card-header-dashbord">
                  <v-row>
                    <v-col
                      cols="12"
                      sm="10"
                      md="10"
                      lg="10"
                      class="d-flex flex-wrap"
                    >
                      Movimentação dos Valores à receber, pagar e saldo?
                    </v-col>
                    <v-col
                      cols="12"
                      sm="2"
                      md="2"
                      lg="2"
                      class="d-flex justify-end"
                    >
                      <v-tooltip
                        top
                        max-width="400"
                        width="400"
                      >
                        <template
                          v-slot:activator="{ on, attrs }"
                        >
                          <v-icon
                            id="iconInformationFatxMetaComercial4"
                            class="text-left"
                            v-bind="attrs"
                            v-on="on"
                            @mouseover="enableTexto('199')"
                          >
                            mdi-information-outline
                          </v-icon>
                        </template>
                        <div
                          v-if="!carregandoTooltip"
                          v-html="textoOrientacao"
                        />
                      </v-tooltip>
                    </v-col>
                  </v-row>
                </div>
                <v-card-actions>
                  <v-row>
                    <v-col
                      id="idMovimentacaoValores"
                      cols="12"
                      sm="12"
                      md="12"
                      lg="12"
                    >
                      <div
                        v-if="loadingMovimentacaoContas"
                        :style="styleObject"
                        class="text-center"
                      >
                        <v-icon
                          light
                          class="custom-loader"
                          :style="styleObject"
                        >
                          mdi-cached
                        </v-icon>
                        Carregando dados...
                      </div>
                      <div
                        v-else-if="error"
                        class="alert alert-danger"
                      >
                        {{ error }}
                      </div>
                      <div
                        v-else
                      >
                        <div
                          id="idTable"
                          style="overflow-x: auto;"
                        >
                          <table
                            style="color: black; border-collapse: collapse;"
                            class="elevation-1"
                          >
                            <thead>
                              <tr>
                                <th
                                  id="dadoMovimentacaoHeader"
                                  style="width: 10%; text-align: center;"
                                  class="black--text title"
                                >
                                  Conta
                                </th>
                                <th
                                  id="dadoMovimentacaoHeader"
                                  style="width: 15%; text-align: center;"
                                  class="black--text title"
                                >
                                  Em Atraso à 7 dias
                                </th>
                                <th
                                  id="dadoMovimentacaoHeader"
                                  style="width: 15%; text-align: center;"
                                  class="black--text title"
                                >
                                  Valores em 7 dias
                                </th>
                                <th
                                  id="dadoMovimentacaoHeader"
                                  style="width: 15%; text-align: center;"
                                  class="black--text title"
                                >
                                  Valores em 14 dias
                                </th>
                                <th
                                  id="dadoMovimentacaoHeader"
                                  style="width: 15%; text-align: center;"
                                  class="black--text title"
                                >
                                  Valores em 21 dias
                                </th>
                                <th
                                  id="dadoMovimentacaoHeader"
                                  style="width: 15%; text-align: center;"
                                  class="black--text title"
                                >
                                  Valores em 28 dias
                                </th>
                                <th
                                  id="dadoMovimentacaoHeader"
                                  style="width: 15%; text-align: center;"
                                  class="black--text title"
                                >
                                  Valores em 35 dias
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr
                                v-for="item in dadosContas"
                                :key="item.id"
                              >
                                <td
                                  id="dadoMovimentacao"
                                  style="text-align: left;"
                                >
                                  {{ item.conta }}
                                </td>
                                <td
                                  id="dadoMovimentacao"
                                  style="text-align: right; cursor: pointer;"
                                  :style="getColorTable(item.valor1, item.conta)"
                                  @click="onClickDetalheValores(item.conta, 'atraso')"
                                >
                                  {{ item.valor1 }}
                                </td>
                                <td
                                  id="dadoMovimentacao"
                                  style="text-align: right; cursor: pointer;"
                                  :style="getColorTable(item.valor2, item.conta)"
                                  @click="onClickDetalheValores(item.conta, '7 dias')"
                                >
                                  {{ item.valor2 }}
                                </td>
                                <td
                                  id="dadoMovimentacao"
                                  style="text-align: right; cursor: pointer;"
                                  :style="getColorTable(item.valor3, item.conta)"
                                  @click="onClickDetalheValores(item.conta, '14 dias')"
                                >
                                  {{ item.valor3 }}
                                </td>
                                <td
                                  id="dadoMovimentacao"
                                  style="text-align: right; cursor: pointer;"
                                  :style="getColorTable(item.valor4, item.conta)"
                                  @click="onClickDetalheValores(item.conta, '21 dias')"
                                >
                                  {{ item.valor4 }}
                                </td>
                                <td
                                  id="dadoMovimentacao"
                                  style="text-align: right; cursor: pointer;"
                                  :style="getColorTable(item.valor5, item.conta)"
                                  @click="onClickDetalheValores(item.conta, '28 dias')"
                                >
                                  {{ item.valor5 }}
                                </td>
                                <td
                                  id="dadoMovimentacao"
                                  style="text-align: right; cursor: pointer;"
                                  :style="getColorTable(item.valor6, item.conta)"
                                  @click="onClickDetalheValores(item.conta, '35 dias')"
                                >
                                  {{ item.valor6 }}
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </v-col>
                  </v-row>
                </v-card-actions>
              </v-card>
            </v-col>
          </v-row>
          <v-row id="movimentacaoFinanceira">
            <v-col
              cols="12"
              sm="12"
              md="12"
              lg="12"
            >
              <v-card
                id="cardDashbord"
                class="mx-auto"
                outlined
              >
                <div class="card-header-dashbord">
                  <v-row>
                    <v-col
                      cols="12"
                      sm="10"
                      md="10"
                      lg="10"
                      class="d-flex flex-wrap"
                    >
                      Qual minha movimentação para os próximos 35 dias?
                    </v-col>
                    <v-col
                      cols="12"
                      sm="2"
                      md="2"
                      lg="2"
                      class="d-flex justify-end"
                    >
                      <v-tooltip
                        top
                        max-width="400"
                        width="400"
                      >
                        <template
                          v-slot:activator="{ on, attrs }"
                        >
                          <v-icon
                            id="iconInformationFatxMetaComercial4"
                            class="text-left"
                            v-bind="attrs"
                            v-on="on"
                            @mouseover="enableTexto('199')"
                          >
                            mdi-information-outline
                          </v-icon>
                        </template>
                        <div
                          v-if="!carregandoTooltip"
                          v-html="textoOrientacao"
                        />
                      </v-tooltip>
                    </v-col>
                  </v-row>
                </div>
                <v-card-actions>
                  <v-row>
                    <v-col
                      id="idMovimentacaoFinanceira"
                      cols="12"
                      sm="12"
                      md="12"
                      lg="12"
                    >
                      <show-projecao-dados-movimentacao-fluxo-caixa />
                    </v-col>
                  </v-row>
                </v-card-actions>
              </v-card>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </div>
    <dashboard-core-snackbar
      v-model="snackbar.visible"
      :visible="snackbar.visible"
      :timeout="snackbar.timeout"
      :color="snackbar.color"
      :message="snackbar.message"
    />
    <template>
      <v-dialog
        v-model="dialog.visible"
        transition="dialog-bottom-transition"
        persistent
        :max-width="dialog.width"
        content-class="custom-dialog-content"
        @keydown.esc="dialog.visible = false"
      >
        <v-card>
          <v-card-title>
            <v-spacer />
            <v-icon
              aria-label="Close"
              @click="dialog.visible = false, excluirPagina = true"
            >
              mdi-close
            </v-icon>
          </v-card-title>
          <v-card-text
            class="text-left"
          >
            <v-row>
              <v-col
                cols="12"
                sm="8"
                md="8"
                lg="8"
                class="text-center"
              >
                <div>
                  <h4>
                    {{ dialog.message }}
                  </h4>
                </div>
              </v-col>
              <v-col
                cols="12"
                sm="4"
                md="4"
                lg="4"
              >
                <v-btn
                  small
                  :color="corPrimaria"
                  dark
                  :loading="imprimindo"
                  @click="imprimirDetalhe(dialog.message, dialog.urlImpressao)"
                >
                  <v-icon>
                    mdi-printer
                  </v-icon>
                  Imprimir
                  <template v-slot:loader>
                    <span>Imprimindo...</span>
                  </template>
                </v-btn>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-text
            class="pb-3 pt-6 text-center"
            style="white-space: pre-line"
          >
            <div
              id="idTableDetalhe"
              style="overflow-x: auto;"
            >
              <table
                style="width: 100%; color: black; border-collapse: collapse;"
                class="elevation-1"
                mobile-breakpoint="0"
              >
                <thead>
                  <tr>
                    <th
                      v-for="h in headersDetalhe"
                      id="dadoMovimentacaoHeader"
                      :key="h.id"
                      style="text-align: center;"
                      class="black--text title"
                    >
                      {{ h.text }}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="item in dadosDetalhamento"
                    :key="item.id"
                  >
                    <td
                      id="dadoMovimentacaoDetalhe"
                      style="text-align: center;"
                    >
                      {{ item.data }}
                    </td>
                    <td
                      id="dadoMovimentacaoDetalhe"
                      style="text-align: left;"
                    >
                      {{ item.cliente }}
                    </td>
                    <td
                      id="dadoMovimentacaoDetalhe"
                      style="text-align: right;"
                      :style="item.carteira === 'R' ? styleObjectValorReceber : styleObjectValorPagar"
                    >
                      {{ item.valor }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog
        v-model="dialogSaldo.visible"
        transition="dialog-bottom-transition"
        persistent
        :max-width="dialog.width"
        content-class="custom-dialog-content"
        @keydown.esc="dialogSaldo.visible = false"
      >
        <v-card>
          <v-card-title>
            <v-spacer />
            <v-icon
              aria-label="Close"
              @click="dialogSaldo.visible = false, excluirPagina = true"
            >
              mdi-close
            </v-icon>
          </v-card-title>
          <v-card-text
            class="text-left"
          >
            <v-row>
              <v-col
                cols="12"
                sm="8"
                md="8"
                lg="8"
                class="text-center"
              >
                <h4>{{ dialogSaldo.message }}</h4>
              </v-col>
              <v-col
                cols="12"
                sm="4"
                md="4"
                lg="4"
              >
                <v-btn
                  small
                  :color="corPrimaria"
                  dark
                  :loading="imprimindo"
                  @click="imprimirDetalheSaldo(dialogSaldo.message, dialogSaldo.urlImpressao)"
                >
                  <v-icon>
                    mdi-printer
                  </v-icon>
                  Imprimir
                  <template v-slot:loader>
                    <span>Imprimindo...</span>
                  </template>
                </v-btn>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-text
            class="pb-3 pt-6 text-center"
            style="white-space: pre-line"
          >
            <div
              id="idTableDetalhe"
              style="overflow-x: auto;"
            >
              <table
                style="width: 100%; color: black; border-collapse: collapse;"
                class="elevation-1"
                mobile-breakpoint="0"
              >
                <thead>
                  <tr>
                    <th
                      v-for="h in headersDetalheSaldo"
                      id="dadoMovimentacaoHeader"
                      :key="h.id"
                      style="text-align: center;"
                      class="black--text title"
                    >
                      {{ h.text }}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="item in dadosDetalhamentoSaldo"
                    :key="item.id"
                  >
                    <td
                      id="dadoMovimentacaoDetalhe"
                      style="text-align: center;"
                    >
                      {{ item.data }}
                    </td>
                    <td
                      id="dadoMovimentacaoDetalhe"
                      style="text-align: right;"
                      :style="item.data !== 'TOTAL' ? styleObjectValorReceberClick : styleObjectValorReceber"
                      @click="item.data !== 'TOTAL' ? onClickReceber(item) : null"
                    >
                      {{ item.receber }}
                    </td>
                    <td
                      id="dadoMovimentacaoDetalhe"
                      style="text-align: right;"
                      :style="item.data !== 'TOTAL' ? styleObjectValorPagarClick : styleObjectValorPagar"
                      @click="item.data !== 'TOTAL' ? onClickPagamento(item) : null"
                    >
                      {{ item.pagamento }}
                    </td>
                    <td
                      id="dadoMovimentacaoDetalhe"
                      style="text-align: right;"
                      :style="getColor(item.saldo)"
                    >
                      {{ item.saldoExibicao }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </v-card-text>
        </v-card>
      </v-dialog>
    </template>
  </v-container>
</template>

<script>
  import utils from '../../../../services/utils'
  import Permissao from '../../../../services/menu'
  import eventEmit from '../../components/core/EventoEmit'
  import FluxoCaixa from '../../../../services/fluxocaixa2'
  import Chart from 'chart.js'
  import html2canvas from 'html2canvas'
  import JSPDF from 'jspdf'
  import 'jspdf-autotable'

  export default {
    name: 'DashboardFluxoCaixa',
    emits: ['updateFluxo', 'enableFaturamento', 'disableLoading', 'disableLoadingGrafico', 'atualizarTexto'],
    components: {
      DashboardCoreSnackbar: () => import('../../components/core/Snackbar'),
      DashboardFiltroDatas: () => import('../../components/core/FiltroDatas'),
      DashoardCardView: () => import('../../components/core/CardView'),
      ShowSaldoTotalFluxoCaixa: () => import('../../components/financeiro/fluxoCaixa/FluxoCaixaSaldoTotal'),
      ShowSaldoContasFluxoCaixa: () => import('../../components/financeiro/fluxoCaixa/FluxoCaixaSaldoContas'),
      ShowProjecaoDadosMovimentacaoFluxoCaixa: () => import('../../components/financeiro/fluxoCaixa2/FluxoCaixaProjecaoDadosMovimentacao2'),
    },
    mixins: [utils],
    data: () => ({
      attrs: '',
      on: '',
      appOnline: navigator.onLine,
      corPrimaria: localStorage.corPrimaria,
      corSecondaria: localStorage.corSecondaria,
      styleObject: {
        color: localStorage.corPrimaria,
      },
      styleSaldoBancario: {
        color: '#4CAF50',
      },
      styleProjecaoReceberDias: {
        color: '#7c7673',
      },
      styleSaldoBancarioValor: {
        color: '#4CAF50',
      },
      styleProjecaoPagar: {
        color: '#f27686',
      },
      styleSaldoBancarioAtrasado: {
        color: '#4CAF50',
      },
      styleSaldoBancario7Dias: {
        color: '#4CAF50',
      },
      styleSaldoBancario14Dias: {
        color: '#4CAF50',
      },
      styleSaldoBancario21Dias: {
        color: '#4CAF50',
      },
      styleSaldoBancario28Dias: {
        color: '#4CAF50',
      },
      styleSaldoBancario35Dias: {
        color: '#4CAF50',
      },
      styleObjectValorReceber: {
        color: '#4780b8',
      },
      styleObjectValorPagar: {
        color: '#f27686',
      },
      styleObjectValorReceberClick: {
        color: '#4780b8',
        cursor: 'pointer',
      },
      styleObjectValorPagarClick: {
        color: '#f27686',
        cursor: 'pointer',
      },
      usuarioIdentificado: false,
      paginaEnable: false,
      snackbar: {
        visible: false,
        color: 'success',
        direction: 'top center',
        message: 'My timeout is set to 3000.',
        timeout: 3000,
      },
      enablePrimeiroDia: false,
      enableUltimoDia: false,
      enableEmpresa: true,
      link: window.location.href,
      permissaoFluxoCaixa: '',
      select: [],
      codigo: 0,
      orientacao: [],
      codigoId: ['195', '196', '199', '391', '392', '393', '394', '395', '396', '397', '398', '399', '400', '401', '402', '403', '404', '405', '406', '407', '408'],
      textoSaldoBancario: '',
      textoProjecaoFinanceira: '',
      textoReceber: '',
      textoPagar: '',
      textoMovimentacao: '',
      textoReceberAtrasado: '',
      textoReceber7Dias: '',
      textoReceber14Dias: '',
      textoReceber21Dias: '',
      textoReceber28Dias: '',
      textoReceber35Dias: '',
      textoPagarAtrasado: '',
      textoPagar7Dias: '',
      textoPagar14Dias: '',
      textoPagar21Dias: '',
      textoPagar28Dias: '',
      textoPagar35Dias: '',
      textoSaldoAtraso7Dias: '',
      textoSaldo7Dias: '',
      textoSaldo14Dias: '',
      textoSaldo21Dias: '',
      textoSaldo28Dias: '',
      textoSaldo35Dias: '',
      chartFluxoCaixa: {},
      valorReceberEmAtraso7Dias: parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
      valorReceber7Dias: parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
      valorReceber14Dias: parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
      valorReceber21Dias: parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
      valorReceber28Dias: parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
      valorReceber35Dias: parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
      valorPagarEmAtraso7Dias: parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
      valorPagar7Dias: parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
      valorPagar14Dias: parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
      valorPagar21Dias: parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
      valorPagar28Dias: parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
      valorPagar35Dias: parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
      valorSaldoAtraso7Dias: parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
      valorSaldo7Dias: parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
      valorSaldo14Dias: parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
      valorSaldo21Dias: parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
      valorSaldo28Dias: parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
      valorSaldo35Dias: parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
      dynamicPaddingFluxoVenda1: '',
      dynamicPaddingFluxoVenda2: '',
      dynamicPaddingFluxoVenda3: '',
      dynamicPaddingFluxoVenda4: '',
      enableBtnPrint: false,
      enableTextoSaldo: false,
      headersContaBancaria: [
        { text: 'Conta Corrente', value: 'desc_conta', width: '200px', class: 'black--text title' },
        { text: 'Saldo Atual', value: 'saldo', width: '200px', align: 'right', class: 'black--text title' },
      ],
      contasBancarias: [],
      headersMovimentacao: [
        { text: 'Período', value: 'periodo', width: '10%', align: 'center', class: 'black--text title' },
        { text: 'Saldo Inicial', value: 'saldo_inicial', width: '20%', align: 'right', class: 'black--text title' },
        { text: 'A Receber', value: 'receber', width: '20%', align: 'right', class: 'black--text title' },
        { text: 'A Pagar', value: 'pagar', width: '20%', align: 'right', class: 'black--text title' },
        { text: 'Saldo Projeto', value: 'saldo_projetado', width: '20%', align: 'right', class: 'black--text title' },
      ],
      dadosMovimentacao: [],
      loadingPrint: false,
      loadingGraficoProjecaoFinanceira: false,
      loadingProjecaoReceber30Dias: false,
      loadingValoresEmAtraso7Dias: false,
      loadingValores7Dias: false,
      loadingValores14Dias: false,
      loadingValores21Dias: false,
      loadingValores28Dias: false,
      loadingValores35Dias: false,
      loadingMovimentacaoContas: false,
      dadosContas: [],
      headersDetalhe: [],
      dadosDetalhamento: [],
      headersDetalheSaldo: [
        { text: 'Data', value: 'data', class: 'black--text title' },
        { text: 'Valor a Receber', value: 'receber', align: 'right', class: 'black--text title' },
        { text: 'Valor a Pagar', value: 'pagamento', align: 'right', class: 'black--text title' },
        { text: 'Saldo', value: 'saldo', align: 'right', class: 'black--text title' },
      ],
      headerTableMovimento: [
        { text: 'Data', value: 'data', class: 'black--text title' },
        { text: 'Valor a Receber', value: 'receber', align: 'right', class: 'black--text title' },
        { text: 'Valor a Pagar', value: 'pagamento', align: 'right', class: 'black--text title' },
        { text: 'Saldo', value: 'saldo', align: 'right', class: 'black--text title' },
      ],
      dadosDetalhamentoSaldo: [],
      headerDetalhamentoSaldo: [
        { text: 'Conta', value: 'conta', class: 'black--text title' },
        { text: 'Em Atraso à 7 dias', value: 'valor1', align: 'right', class: 'black--text title' },
        { text: 'Valores em 7 dias', value: 'valor1', align: 'right', class: 'black--text title' },
        { text: 'Valores em 14 dias', value: 'valor1', align: 'right', class: 'black--text title' },
        { text: 'Valores em 21 dias', value: 'valor1', align: 'right', class: 'black--text title' },
        { text: 'Valores em 28 dias', value: 'valor1', align: 'right', class: 'black--text title' },
        { text: 'Valores em 35 dias', value: 'valor1', align: 'right', class: 'black--text title' },
      ],
      dialog: {
        visible: false,
        message: '',
        valor: 0,
        urlImpressao: '',
        width: '1000px',
      },
      dialogSaldo: {
        visible: false,
        message: '',
        valor: 0,
        width: '1000px',
      },
      error: '',
      imprimindo: false,
      mobile: false,
      textoOrientacao: '',
      carregandoTooltip: false,
      codigoAtual: null,
    }),

    computed: {
      computedDateFormatted () {
        return this.formatDate(this.date)
      },

      computedPrimeiroDia () {
        return this.formatDate(this.primeiroDia)
      },
    },

    watch: {
      date (val) {
        this.dateFormatted = this.formatDate(this.date)
      },
    },

    created () {
      eventEmit.$on('update-dados', this.handleUpdateDados)

      eventEmit.$on('update-dados-saldo-contas', this.handleDadosSaldoContas)

      eventEmit.$on('update-movimentacao-contas', this.handleDadosMovimentacaoContas)
    },

    beforeDestroy () {
      eventEmit.$off('update-dados', this.handleUpdateDados)

      eventEmit.$off('update-dados-saldo-contas', this.handleDadosSaldoContas)

      eventEmit.$off('update-movimentacao-contas', this.handleDadosMovimentacaoContas)

      window.removeEventListener('resize', this.updateDynamicPadding)
    },

    mounted () {
      if (localStorage.tokencontrato) {
        eventEmit.$emit('atualizar_texto', 'Fluxo de Caixa')

        this.updateDynamicPadding()

        window.addEventListener('resize', this.updateDynamicPadding)

        this.mobile = (window.innerWidth < 600)

        this.usuarioIdentificado = true
      } else {
        this.usuarioIdentificado = false
        localStorage.removeItem('username')
        localStorage.removeItem('email')
        localStorage.removeItem('nome')
        localStorage.removeItem('usuarioIdentificado')
        this.$router.push('/login')
      }
    },

    methods: {
      updateDynamicPadding () {
        if (window.innerWidth > 1800) {
          this.dynamicPaddingFluxoVenda1 = 'padding-right: 28rem !important'

          this.dynamicPaddingFluxoVenda2 = 'padding-right: 45rem !important'

          this.dynamicPaddingFluxoVenda3 = 'padding-right: 3rem !important'

          this.dynamicPaddingFluxoVenda4 = 'padding-right: 98rem !important'
        } else if (window.innerWidth > 1380 && window.innerWidth <= 1800) {
          this.dynamicPaddingFluxoVenda1 = 'padding-right: 15rem !important'

          this.dynamicPaddingFluxoVenda2 = 'padding-right: 24rem !important'

          this.dynamicPaddingFluxoVenda3 = 'padding-right: 2rem !important'

          this.dynamicPaddingFluxoVenda4 = 'padding-right: 65rem !important'
        } else if (window.innerWidth > 380 && window.innerWidth < 680) {
          this.dynamicPaddingFluxoVenda1 = 'padding-right: 5rem !important'

          this.dynamicPaddingFluxoVenda2 = 'padding-right: 5rem !important'

          this.dynamicPaddingFluxoVenda3 = 'padding-right: 5rem !important'

          this.dynamicPaddingFluxoVenda4 = 'padding-right: 5rem !important'
        } else if (window.innerWidth > 681 && window.innerWidth < 1080) {
          this.dynamicPaddingFluxoVenda1 = 'padding-right: 24rem !important'

          this.dynamicPaddingFluxoVenda2 = 'padding-right: 24rem !important'

          this.dynamicPaddingFluxoVenda3 = 'padding-right: 24rem !important'

          this.dynamicPaddingFluxoVenda4 = 'padding-right: 24rem !important'
        } else {
          this.dynamicPaddingFluxoVenda1 = 'padding-right: 14rem !important'

          this.dynamicPaddingFluxoVenda2 = 'padding-right: 22rem !important'

          this.dynamicPaddingFluxoVenda3 = 'padding-right: 2rem !important'

          this.dynamicPaddingFluxoVenda4 = 'padding-right: 60rem !important'
        }
      },

      async enableTexto (value) {
        if (this.codigoAtual === value && this.textoOrientacao) return

        this.codigoAtual = value
        this.carregandoTooltip = true
        this.textoOrientacao = ''

        try {
          const resposta = await Permissao.showOrientacaoIndicador(localStorage.username, localStorage.tokencontrato, value)

          if (resposta.data.status) {
            this.textoOrientacao = resposta.data.orientacao
            this.codigo = value
          }
        } catch (e) {
          if (e.message === 'Network Error') {
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        } finally {
          this.carregandoTooltip = false
        }
      },

      handleUpdateDados (primeiroDia, dataFinal, select) {
        this.select = select

        this.updateDate()
      },

      handleDadosSaldoContas (contas) {
        this.contasBancarias = contas
      },

      handleDadosMovimentacaoContas (dados) {
        this.dadosMovimentacao = dados
      },

      styleInicial () {
        this.styleSaldoBancarioAtrasado = {
          color: '#4CAF50',
        }
        this.styleSaldoBancario7Dias = {
          color: '#4CAF50',
        }
        this.styleSaldoBancario14Dias = {
          color: '#4CAF50',
        }

        this.styleSaldoBancario21Dias = {
          color: '#4CAF50',
        }
        this.styleSaldoBancario28Dias = {
          color: '#4CAF50',
        }
        this.styleSaldoBancario35Dias = {
          color: '#4CAF50',
        }
      },

      async updateDate () {
        this.contasBancarias = []
        this.dadosMovimentacao = []

        this.styleInicial()

        eventEmit.$emit('update-fluxo', this.select)

        this.valorReceberEmAtraso7Dias = parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
        this.valorReceber7Dias = parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
        this.valorReceber14Dias = parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
        this.valorReceber21Dias = parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
        this.valorReceber28Dias = parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
        this.valorReceber35Dias = parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })

        this.valorPagarEmAtraso7Dias = parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
        this.valorPagar7Dias = parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
        this.valorPagar14Dias = parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
        this.valorPagar21Dias = parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
        this.valorPagar28Dias = parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
        this.valorPagar35Dias = parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })

        this.valorSaldoAtraso7Dias = parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
        this.valorSaldo7Dias = parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
        this.valorSaldo14Dias = parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
        this.valorSaldo21Dias = parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
        this.valorSaldo28Dias = parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
        this.valorSaldo35Dias = parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })

        if (this.chartFluxoCaixa.data) {
          this.chartFluxoCaixa.destroy()
        }

        this.dadosContas = []

        this.loadingGraficoProjecaoFinanceira = true
        this.loadingValoresEmAtraso7Dias = true
        this.loadingValores7Dias = true
        this.loadingValores14Dias = true
        this.loadingValores21Dias = true
        this.loadingValores28Dias = true
        this.loadingValores35Dias = true
        this.loadingMovimentacaoContas = true

        await FluxoCaixa.showGraficoProjecaoFinanceiraFC2(localStorage.username, localStorage.tokencontrato, this.select).then(resposta => {
          if (resposta.data.status) {
            const ctx = document.getElementById('myChart17').getContext('2d')

            var mobile = !(window.innerWidth < 600)

            this.chartFluxoCaixa = new Chart(ctx, {
              type: 'bar',
              data: {
                labels: resposta.data.data,
                datasets: [
                  {
                    label: 'Projeção Financeira',
                    data: resposta.data.valorReceber,
                    backgroundColor: resposta.data.cores,
                    order: 1,
                    tension: 0,
                    pointRadius: 0.7,
                  },
                ],
              },
              options: {
                scales: {
                  y: {
                    beginAtZero: true,
                  },
                  xAxes: [{
                    gridLines: {
                      display: false,
                    },
                    display: mobile,
                  }],
                  yAxes: [{
                    gridLines: {
                      display: false,
                    },
                    ticks: {
                      callback: function (label) {
                        return label.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
                      },
                    },
                    display: mobile,
                  }],
                },
                legend: {
                  display: false,
                },
                tooltips: {
                  callbacks: {
                    mode: 'label',
                    label: (tooltipItem, data) => {
                      return data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index].toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
                    },
                  },
                },
              },
            })
          } else if (resposta.data.text === 'Não há dados para exibição do gráfico') {
            this.text = resposta.data.text
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.error = e.message
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        }).finally(f => { this.loadingGraficoProjecaoFinanceira = false })

        await FluxoCaixa.showValoresEmAtraso7Dias(localStorage.tokencontrato, this.select).then(resposta => {
          if (resposta.data.status) {
            this.valorReceberEmAtraso7Dias = parseFloat(resposta.data.valorReceberAtrasado).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })

            this.valorPagarEmAtraso7Dias = parseFloat(resposta.data.valorPagarAtrasado).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })

            const saldo = resposta.data.valorReceberAtrasado - resposta.data.valorPagarAtrasado

            this.valorSaldoAtraso7Dias = parseFloat(saldo).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })

            this.styleSaldoAtrasado(saldo)
          } else if (resposta.data.text === 'Contrato não encontrado') {
            this.error = resposta.data.text

            this.showSnackbar('error', 3000, resposta.data.text)
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.error = e.message
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        }).finally(f => { this.loadingValoresEmAtraso7Dias = false })

        await FluxoCaixa.showValoresEm7Dias(localStorage.tokencontrato, this.select).then(resposta => {
          if (resposta.data.status) {
            this.valorReceber7Dias = parseFloat(resposta.data.valorReceber).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })

            this.valorPagar7Dias = parseFloat(resposta.data.valorPagar).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })

            const saldo = resposta.data.valorReceber - resposta.data.valorPagar

            this.valorSaldo7Dias = parseFloat(saldo).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })

            this.styleSaldo7Dias(saldo)
          } else if (resposta.data.text === 'Contrato não encontrado') {
            this.error = resposta.data.text

            this.showSnackbar('error', 3000, resposta.data.text)
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.error = e.message
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        }).finally(f => { this.loadingValores7Dias = false })

        await FluxoCaixa.showValoresEm14Dias(localStorage.tokencontrato, this.select).then(resposta => {
          if (resposta.data.status) {
            this.valorReceber14Dias = parseFloat(resposta.data.valorReceber).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })

            this.valorPagar14Dias = parseFloat(resposta.data.valorPagar).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })

            const saldo = resposta.data.valorReceber - resposta.data.valorPagar

            this.valorSaldo14Dias = parseFloat(saldo).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })

            this.styleSaldo14Dias(saldo)
          } else if (resposta.data.text === 'Contrato não encontrado') {
            this.error = resposta.data.text

            this.showSnackbar('error', 3000, resposta.data.text)
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.error = e.message
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        }).finally(f => { this.loadingValores14Dias = false })

        await FluxoCaixa.showValoresEm21Dias(localStorage.tokencontrato, this.select).then(resposta => {
          if (resposta.data.status) {
            this.valorReceber21Dias = parseFloat(resposta.data.valorReceber).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })

            this.valorPagar21Dias = parseFloat(resposta.data.valorPagar).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })

            const saldo = resposta.data.valorReceber - resposta.data.valorPagar

            this.valorSaldo21Dias = parseFloat(saldo).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })

            this.styleSaldo21Dias(saldo)
          } else if (resposta.data.text === 'Contrato não encontrado') {
            this.error = resposta.data.text

            this.showSnackbar('error', 3000, resposta.data.text)
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.error = e.message
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        }).finally(f => { this.loadingValores21Dias = false })

        await FluxoCaixa.showValoresEm28Dias(localStorage.tokencontrato, this.select).then(resposta => {
          if (resposta.data.status) {
            this.valorReceber28Dias = parseFloat(resposta.data.valorReceber).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })

            this.valorPagar28Dias = parseFloat(resposta.data.valorPagar).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })

            const saldo = resposta.data.valorReceber - resposta.data.valorPagar

            this.valorSaldo28Dias = parseFloat(saldo).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })

            this.styleSaldo28Dias(saldo)
          } else if (resposta.data.text === 'Contrato não encontrado') {
            this.error = resposta.data.text

            this.showSnackbar('error', 3000, resposta.data.text)
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.error = e.message
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        }).finally(f => { this.loadingValores28Dias = false })

        await FluxoCaixa.showValoresEm35Dias(localStorage.tokencontrato, this.select).then(resposta => {
          if (resposta.data.status) {
            this.valorReceber35Dias = parseFloat(resposta.data.valorReceber).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })

            this.valorPagar35Dias = parseFloat(resposta.data.valorPagar).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })

            const saldo = resposta.data.valorReceber - resposta.data.valorPagar

            this.valorSaldo35Dias = parseFloat(saldo).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })

            this.styleSaldo35Dias(saldo)
          } else if (resposta.data.text === 'Contrato não encontrado') {
            this.error = resposta.data.text

            this.showSnackbar('error', 3000, resposta.data.text)
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.error = e.message
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        }).finally(f => { this.loadingValores35Dias = false })

        try {
          this.dadosContas.push({
            conta: 'Receber',
            valor1: this.valorReceberEmAtraso7Dias,
            valor2: this.valorReceber7Dias,
            valor3: this.valorReceber14Dias,
            valor4: this.valorReceber21Dias,
            valor5: this.valorReceber28Dias,
            valor6: this.valorReceber35Dias,
          })

          this.dadosContas.push({
            conta: 'Pagar',
            valor1: this.valorPagarEmAtraso7Dias,
            valor2: this.valorPagar7Dias,
            valor3: this.valorPagar14Dias,
            valor4: this.valorPagar21Dias,
            valor5: this.valorPagar28Dias,
            valor6: this.valorPagar35Dias,
          })

          this.dadosContas.push({
            conta: 'Saldo',
            valor1: this.valorSaldoAtraso7Dias,
            valor2: this.valorSaldo7Dias,
            valor3: this.valorSaldo14Dias,
            valor4: this.valorSaldo21Dias,
            valor5: this.valorSaldo28Dias,
            valor6: this.valorSaldo35Dias,
          })
        } finally {
          this.loadingMovimentacaoContas = false

          this.enableBtnPrint = true
        }
      },

      getColorTable (value, conta) {
        if (conta === 'Saldo') {
          var negativo = value.substr(0, 1)

          if (negativo === '-') {
            return 'color: #f27686'
          } else {
            return 'color: #4CAF50'
          }
        } else if (conta === 'Pagar') {
          return 'color: #f27686'
        } else {
          return 'color: #4780b8'
        }
      },

      onClickDetalheValores (conta, valor) {
        if (conta === 'Saldo') {
          this.detalheSaldo(valor)
        } else if (conta === 'Pagar') {
          this.detalhePagar(valor)
        } else {
          this.detalheReceber(valor)
        }
      },

      async detalheReceber (valor) {
        this.headersDetalhe = [
          { text: 'Data', value: 'data', class: 'black--text title' },
          { text: 'Cliente', value: 'nome', class: 'black--text title' },
          { text: 'Valor', value: 'valor', align: 'right', class: 'black--text title' },
        ]

        this.dadosDetalhamento = []

        if (valor === 'atraso') {
          await FluxoCaixa.showDadosDelhamentoReceberEmAtraso(localStorage.tokencontrato, this.select).then(resposta => {
            if (resposta.data.status) {
              this.dadosDetalhamento = resposta.data.dadosMovimentacao.map((item) => {
                var listaDetalhamento = ({
                  data: item.data,
                  cliente: item.nome,
                  valor: parseFloat(item.valor).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
                  carteira: 'R',
                })

                return listaDetalhamento
              })

              this.enableBtnPrint = true
              this.showDialog('Detalhamento Fluxo de Caixa contas a receber em atraso à 7 dias', 'relatorio_fluxo_caixa_contas_receber_em_atraso.pdf')
            } else if (resposta.data.msg === 'Não há dados para detalhamento no período selecionado') {
              this.dadosDetalhamento = []

              this.showSnackbar('error', 3000, resposta.data.msg)
            }
          }).catch(e => {
            if (e.message === 'Network Error') {
              this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
            }
          }).finally(f => { this.loading = false })
        } else if (valor === '7 dias') {
          await FluxoCaixa.showDadosDelhamentoReceberEm7Dias(localStorage.tokencontrato, this.select).then(resposta => {
            if (resposta.data.status) {
              this.dadosDetalhamento = resposta.data.dadosMovimentacao.map((item) => {
                var listaDetalhamento = ({
                  data: item.data,
                  cliente: item.nome,
                  valor: parseFloat(item.valor).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
                  carteira: 'R',
                })

                return listaDetalhamento
              })

              this.enableBtnPrint = true
              this.showDialog('Detalhamento Fluxo de Caixa contas a receber em 7 dias', 'relatorio_fluxo_caixa_contas_receber_em_7_dias.pdf')
            } else if (resposta.data.msg === 'Não há dados para detalhamento no período selecionado') {
              this.dadosDetalhamento = []

              this.showSnackbar('error', 3000, resposta.data.msg)
            }
          }).catch(e => {
            if (e.message === 'Network Error') {
              this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
            }
          }).finally(f => { this.loading = false })
        } else if (valor === '14 dias') {
          await FluxoCaixa.showDadosDelhamentoReceberEm14Dias(localStorage.tokencontrato, this.select).then(resposta => {
            if (resposta.data.status) {
              this.dadosDetalhamento = resposta.data.dadosMovimentacao.map((item) => {
                var listaDetalhamento = ({
                  data: item.data,
                  cliente: item.nome,
                  valor: parseFloat(item.valor).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
                  carteira: 'R',
                })

                return listaDetalhamento
              })

              this.enableBtnPrint = true
              this.showDialog('Detalhamento Fluxo de Caixa contas a receber em 14 dias', 'relatorio_fluxo_caixa_contas_receber_em_14_dias.pdf')
            } else if (resposta.data.msg === 'Não há dados para detalhamento no período selecionado') {
              this.dadosDetalhamento = []

              this.showSnackbar('error', 3000, resposta.data.msg)
            }
          }).catch(e => {
            if (e.message === 'Network Error') {
              this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
            }
          }).finally(f => { this.loading = false })
        } else if (valor === '21 dias') {
          await FluxoCaixa.showDadosDelhamentoReceberEm21Dias(localStorage.tokencontrato, this.select).then(resposta => {
            if (resposta.data.status) {
              this.dadosDetalhamento = resposta.data.dadosMovimentacao.map((item) => {
                var listaDetalhamento = ({
                  data: item.data,
                  cliente: item.nome,
                  valor: parseFloat(item.valor).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
                  carteira: 'R',
                })

                return listaDetalhamento
              })

              this.enableBtnPrint = true
              this.showDialog('Detalhamento Fluxo de Caixa contas a receber em 21 dias', 'relatorio_fluxo_caixa_contas_receber_em_21_dias.pdf')
            } else if (resposta.data.msg === 'Não há dados para detalhamento no período selecionado') {
              this.dadosDetalhamento = []

              this.showSnackbar('error', 3000, resposta.data.msg)
            }
          }).catch(e => {
            if (e.message === 'Network Error') {
              this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
            }
          }).finally(f => { this.loading = false })
        } else if (valor === '28 dias') {
          await FluxoCaixa.showDadosDelhamentoReceberEm28Dias(localStorage.tokencontrato, this.select).then(resposta => {
            if (resposta.data.status) {
              this.dadosDetalhamento = resposta.data.dadosMovimentacao.map((item) => {
                var listaDetalhamento = ({
                  data: item.data,
                  cliente: item.nome,
                  valor: parseFloat(item.valor).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
                  carteira: 'R',
                })

                return listaDetalhamento
              })

              this.enableBtnPrint = true
              this.showDialog('Detalhamento Fluxo de Caixa contas a receber em 28 dias', 'relatorio_fluxo_caixa_contas_receber_em_28_dias.pdf')
            } else if (resposta.data.msg === 'Não há dados para detalhamento no período selecionado') {
              this.dadosDetalhamento = []

              this.showSnackbar('error', 3000, resposta.data.msg)
            }
          }).catch(e => {
            if (e.message === 'Network Error') {
              this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
            }
          }).finally(f => { this.loading = false })
        } else {
          await FluxoCaixa.showDadosDelhamentoReceberEm35Dias(localStorage.tokencontrato, this.select).then(resposta => {
            if (resposta.data.status) {
              this.dadosDetalhamento = resposta.data.dadosMovimentacao.map((item) => {
                var listaDetalhamento = ({
                  data: item.data,
                  cliente: item.nome,
                  valor: parseFloat(item.valor).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
                  carteira: 'R',
                })

                return listaDetalhamento
              })

              this.enableBtnPrint = true
              this.showDialog('Detalhamento Fluxo de Caixa contas a receber em 35 dias', 'relatorio_fluxo_caixa_contas_receber_em_35_dias.pdf')
            } else if (resposta.data.msg === 'Não há dados para detalhamento no período selecionado') {
              this.dadosDetalhamento = []

              this.showSnackbar('error', 3000, resposta.data.msg)
            }
          }).catch(e => {
            if (e.message === 'Network Error') {
              this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
            }
          }).finally(f => { this.loading = false })
        }
      },

      async detalhePagar (valor) {
        this.headersDetalhe = [
          { text: 'Data', value: 'data', class: 'black--text title' },
          { text: 'Fornecedor', value: 'nome', class: 'black--text title' },
          { text: 'Valor', value: 'valor', align: 'right', class: 'black--text title' },
        ]

        this.dadosDetalhamento = []

        if (valor === 'atraso') {
          await FluxoCaixa.showDadosDelhamentoPagarEmAtraso(localStorage.tokencontrato, this.select).then(resposta => {
            if (resposta.data.status) {
              this.dadosDetalhamento = resposta.data.dadosMovimentacao.map((item) => {
                var listaDetalhamento = ({
                  data: item.data,
                  cliente: item.nome,
                  valor: parseFloat(item.valor).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
                  carteira: 'P',
                })

                return listaDetalhamento
              })

              this.enableBtnPrint = true
              this.showDialog('Detalhamento Fluxo de Caixa ontas a pagar em atraso', 'relatorio_fluxo_caixa_contas_pagar_em_atraso.pdf')
            } else if (resposta.data.msg === 'Não há dados para detalhamento no período selecionado') {
              this.dadosDetalhamento = []

              this.showSnackbar('error', 3000, resposta.data.msg)
            }
          }).catch(e => {
            if (e.message === 'Network Error') {
              this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
            }
          }).finally(f => { this.loading = false })
        } else if (valor === '7 dias') {
          await FluxoCaixa.showDadosDelhamentoPagarEm7Dias(localStorage.tokencontrato, this.select).then(resposta => {
            if (resposta.data.status) {
              this.dadosDetalhamento = resposta.data.dadosMovimentacao.map((item) => {
                var listaDetalhamento = ({
                  data: item.data,
                  cliente: item.nome,
                  valor: parseFloat(item.valor).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
                  carteira: 'P',
                })

                return listaDetalhamento
              })

              this.enableBtnPrint = true
              this.showDialog('Detalhamento Fluxo de Caixa contas a pagar em 7 dias', 'relatorio_fluxo_caixa_contas_pagar_em_7_dias.pdf')
            } else if (resposta.data.msg === 'Não há dados para detalhamento no período selecionado') {
              this.dadosDetalhamento = []

              this.showSnackbar('error', 3000, resposta.data.msg)
            }
          }).catch(e => {
            if (e.message === 'Network Error') {
              this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
            }
          }).finally(f => { this.loading = false })
        } else if (valor === '14 dias') {
          await FluxoCaixa.showDadosDelhamentoPagarEm14Dias(localStorage.tokencontrato, this.select).then(resposta => {
            if (resposta.data.status) {
              this.dadosDetalhamento = resposta.data.dadosMovimentacao.map((item) => {
                var listaDetalhamento = ({
                  data: item.data,
                  cliente: item.nome,
                  valor: parseFloat(item.valor).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
                  carteira: 'P',
                })

                return listaDetalhamento
              })

              this.enableBtnPrint = true
              this.showDialog('Detalhamento Fluxo de Caixa contas a pagar em 14 dias', 'relatorio_fluxo_caixa_contas_pagar_em_14_dias.pdf')
            } else if (resposta.data.msg === 'Não há dados para detalhamento no período selecionado') {
              this.dadosDetalhamento = []

              this.showSnackbar('error', 3000, resposta.data.msg)
            }
          }).catch(e => {
            if (e.message === 'Network Error') {
              this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
            }
          }).finally(f => { this.loading = false })
        } else if (valor === '21 dias') {
          await FluxoCaixa.showDadosDelhamentoPagarEm21Dias(localStorage.tokencontrato, this.select).then(resposta => {
            if (resposta.data.status) {
              this.dadosDetalhamento = resposta.data.dadosMovimentacao.map((item) => {
                var listaDetalhamento = ({
                  data: item.data,
                  cliente: item.nome,
                  valor: parseFloat(item.valor).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
                  carteira: 'P',
                })

                return listaDetalhamento
              })

              this.enableBtnPrint = true
              this.showDialog('Detalhamento Fluxo de Caixa contas a pagar em 21 dias', 'relatorio_fluxo_caixa_contas_pagar_em_21_dias.pdf')
            } else if (resposta.data.msg === 'Não há dados para detalhamento no período selecionado') {
              this.dadosDetalhamento = []

              this.showSnackbar('error', 3000, resposta.data.msg)
            }
          }).catch(e => {
            if (e.message === 'Network Error') {
              this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
            }
          }).finally(f => { this.loading = false })
        } else if (valor === '28 dias') {
          await FluxoCaixa.showDadosDelhamentoPagarEm28Dias(localStorage.tokencontrato, this.select).then(resposta => {
            if (resposta.data.status) {
              this.dadosDetalhamento = resposta.data.dadosMovimentacao.map((item) => {
                var listaDetalhamento = ({
                  data: item.data,
                  cliente: item.nome,
                  valor: parseFloat(item.valor).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
                  carteira: 'P',
                })

                return listaDetalhamento
              })

              this.enableBtnPrint = true
              this.showDialog('Detalhamento Fluxo de Caixa contas a pagar em 28 dias', 'relatorio_fluxo_caixa_contas_pagar_em_28_dias.pdf')
            } else if (resposta.data.msg === 'Não há dados para detalhamento no período selecionado') {
              this.dadosDetalhamento = []

              this.showSnackbar('error', 3000, resposta.data.msg)
            }
          }).catch(e => {
            if (e.message === 'Network Error') {
              this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
            }
          }).finally(f => { this.loading = false })
        } else {
          await FluxoCaixa.showDadosDelhamentoPagarEm35Dias(localStorage.tokencontrato, this.select).then(resposta => {
            if (resposta.data.status) {
              this.dadosDetalhamento = resposta.data.dadosMovimentacao.map((item) => {
                var listaDetalhamento = ({
                  data: item.data,
                  cliente: item.nome,
                  valor: parseFloat(item.valor).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
                  carteira: 'P',
                })

                return listaDetalhamento
              })

              this.enableBtnPrint = true
              this.showDialog('Detalhamento Fluxo de Caixa contas a pagar em 35 dias', 'relatorio_fluxo_caixa_contas_pagar_em_35_dias.pdf')
            } else if (resposta.data.msg === 'Não há dados para detalhamento no período selecionado') {
              this.dadosDetalhamento = []

              this.showSnackbar('error', 3000, resposta.data.msg)
            }
          }).catch(e => {
            if (e.message === 'Network Error') {
              this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
            }
          }).finally(f => { this.loading = false })
        }
      },

      async detalheSaldo (valor) {
        this.dadosDetalhamentoSaldo = []

        if (valor === 'atraso') {
          await FluxoCaixa.showDadosDelhamentoSaldoEmAtraso(localStorage.tokencontrato, this.select).then(resposta => {
            if (resposta.data.status) {
              this.dadosDetalhamentoSaldo = resposta.data.dadosMovimentacao.map((item) => {
                var listaDetalhamento = ({
                  data: item.data,
                  receber: parseFloat(item.receber).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
                  pagamento: parseFloat(item.pagar).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
                  saldo: item.saldo,
                  saldoExibicao: parseFloat(item.saldo).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
                })

                return listaDetalhamento
              })

              this.enableBtnPrint = true
              this.showDialogSaldo('Detalhamento Fluxo de Caixa Saldo em atraso em 7 dias', 'relatorio_fluxo_caixa_saldo_atrasado_em_7_dias.pdf')
            } else if (resposta.data.msg === 'Não há dados para detalhamento no período selecionado') {
              this.dadosDetalhamentoSaldo = []

              this.showSnackbar('error', 3000, resposta.data.msg)
            }
          }).catch(e => {
            if (e.message === 'Network Error') {
              this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
            }
          }).finally(f => { this.loading = false })
        } else if (valor === '7 dias') {
          await FluxoCaixa.showDadosDelhamentoSaldoEm7Dias(localStorage.tokencontrato, this.select).then(resposta => {
            if (resposta.data.status) {
              this.dadosDetalhamentoSaldo = resposta.data.dadosMovimentacao.map((item) => {
                var listaDetalhamento = ({
                  data: item.data,
                  receber: parseFloat(item.receber).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
                  pagamento: parseFloat(item.pagar).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
                  saldo: item.saldo,
                  saldoExibicao: parseFloat(item.saldo).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
                })

                return listaDetalhamento
              })

              this.enableBtnPrint = true
              this.showDialogSaldo('Detalhamento Fluxo de Caixa Saldo em 7 dias', 'relatorio_fluxo_caixa_saldo_em_7_dias.pdf')
            } else if (resposta.data.msg === 'Não há dados para detalhamento no período selecionado') {
              this.dadosDetalhamentoSaldo = []

              this.showSnackbar('error', 3000, resposta.data.msg)
            }
          }).catch(e => {
            if (e.message === 'Network Error') {
              this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
            }
          }).finally(f => { this.loading = false })
        } else if (valor === '14 dias') {
          await FluxoCaixa.showDadosDelhamentoSaldoEm14Dias(localStorage.tokencontrato, this.select).then(resposta => {
            if (resposta.data.status) {
              this.dadosDetalhamentoSaldo = resposta.data.dadosMovimentacao.map((item) => {
                var listaDetalhamento = ({
                  data: item.data,
                  receber: parseFloat(item.receber).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
                  pagamento: parseFloat(item.pagar).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
                  saldo: item.saldo,
                  saldoExibicao: parseFloat(item.saldo).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
                })

                return listaDetalhamento
              })

              this.enableBtnPrint = true
              this.showDialogSaldo('Detalhamento Fluxo de Caixa Saldo em 14 dias', 'relatorio_fluxo_caixa_saldo_em_14_dias.pdf')
            } else if (resposta.data.msg === 'Não há dados para detalhamento no período selecionado') {
              this.dadosDetalhamentoSaldo = []

              this.showSnackbar('error', 3000, resposta.data.msg)
            }
          }).catch(e => {
            if (e.message === 'Network Error') {
              this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
            }
          }).finally(f => { this.loading = false })
        } else if (valor === '21 dias') {
          await FluxoCaixa.showDadosDelhamentoSaldoEm21Dias(localStorage.tokencontrato, this.select).then(resposta => {
            if (resposta.data.status) {
              this.dadosDetalhamentoSaldo = resposta.data.dadosMovimentacao.map((item) => {
                var listaDetalhamento = ({
                  data: item.data,
                  receber: parseFloat(item.receber).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
                  pagamento: parseFloat(item.pagar).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
                  saldo: item.saldo,
                  saldoExibicao: parseFloat(item.saldo).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
                })

                return listaDetalhamento
              })

              this.enableBtnPrint = true
              this.showDialogSaldo('Detalhamento Fluxo de Caixa Saldo em 21 dias', 'relatorio_fluxo_caixa_saldo_em_21_dias.pdf')
            } else if (resposta.data.msg === 'Não há dados para detalhamento no período selecionado') {
              this.dadosDetalhamentoSaldo = []

              this.showSnackbar('error', 3000, resposta.data.msg)
            }
          }).catch(e => {
            if (e.message === 'Network Error') {
              this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
            }
          }).finally(f => { this.loading = false })
        } else if (valor === '28 dias') {
          await FluxoCaixa.showDadosDelhamentoSaldoEm28Dias(localStorage.tokencontrato, this.select).then(resposta => {
            if (resposta.data.status) {
              this.dadosDetalhamentoSaldo = resposta.data.dadosMovimentacao.map((item) => {
                var listaDetalhamento = ({
                  data: item.data,
                  receber: parseFloat(item.receber).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
                  pagamento: parseFloat(item.pagar).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
                  saldo: item.saldo,
                  saldoExibicao: parseFloat(item.saldo).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
                })

                return listaDetalhamento
              })

              this.enableBtnPrint = true
              this.showDialogSaldo('Detalhamento Fluxo de Caixa Saldo em 28 dias', 'relatorio_fluxo_caixa_saldo_em_28_dias.pdf')
            } else if (resposta.data.msg === 'Não há dados para detalhamento no período selecionado') {
              this.dadosDetalhamentoSaldo = []

              this.showSnackbar('error', 3000, resposta.data.msg)
            }
          }).catch(e => {
            if (e.message === 'Network Error') {
              this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
            }
          }).finally(f => { this.loading = false })
        } else {
          await FluxoCaixa.showDadosDelhamentoSaldoEm35Dias(localStorage.tokencontrato, this.select).then(resposta => {
            if (resposta.data.status) {
              this.dadosDetalhamentoSaldo = resposta.data.dadosMovimentacao.map((item) => {
                var listaDetalhamento = ({
                  data: item.data,
                  receber: parseFloat(item.receber).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
                  pagamento: parseFloat(item.pagar).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
                  saldo: item.saldo,
                  saldoExibicao: parseFloat(item.saldo).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
                })

                return listaDetalhamento
              })

              this.enableBtnPrint = true
              this.showDialogSaldo('Detalhamento Fluxo de Caixa Saldo em 35 dias', 'relatorio_fluxo_caixa_saldo_em_35_dias.pdf')
            } else if (resposta.data.msg === 'Não há dados para detalhamento no período selecionado') {
              this.dadosDetalhamentoSaldo = []

              this.showSnackbar('error', 3000, resposta.data.msg)
            }
          }).catch(e => {
            if (e.message === 'Network Error') {
              this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
            }
          }).finally(f => { this.loading = false })
        }
      },

      showDialog (message, urlImpressao) {
        this.dialog.visible = true
        this.dialog.message = message
        this.dialog.urlImpressao = urlImpressao
        this.dialog.width = this.mobile ? '400px' : '1000px'
      },

      showDialogSaldo (message, urlImpressao) {
        this.dialogSaldo.visible = true
        this.dialogSaldo.message = message
        this.dialogSaldo.urlImpressao = urlImpressao
        this.dialogSaldo.width = this.mobile ? '400px' : '1000px'
      },

      getColor (value) {
        if (value < 0) {
          return 'color: #f27686;'
        } else {
          return 'color: #4CAF50;'
        }
      },

      styleSaldoAtrasado (value) {
        if (value < 0) {
          this.styleSaldoBancarioAtrasado = {
            color: '#f27686',
          }
        }
      },

      styleSaldo7Dias (value) {
        if (value < 0) {
          this.styleSaldoBancario7Dias = {
            color: '#f27686',
          }
        }
      },

      styleSaldo14Dias (value) {
        if (value < 0) {
          this.styleSaldoBancario14Dias = {
            color: '#f27686',
          }
        }
      },

      styleSaldo21Dias (value) {
        if (value < 0) {
          this.styleSaldoBancario21Dias = {
            color: '#f27686',
          }
        }
      },

      styleSaldo28Dias (value) {
        if (value < 0) {
          this.styleSaldoBancario28Dias = {
            color: '#f27686',
          }
        }
      },

      styleSaldo35Dias (value) {
        if (value < 0) {
          this.styleSaldoBancario35Dias = {
            color: '#f27686',
          }
        }
      },

      async imprimir () {
        try {
          this.loadingPrint = true
          this.enableTextoSaldo = true

          await this.executarImpressao()
        } catch (error) {
          console.error('Erro ao imprimir:', error)
        } finally {
          this.loadingPrint = false
        }
      },

      async executarImpressao () {
        return new Promise(resolve => {
          setTimeout(() => {
            this.print()

            resolve()
          }, 3000)
        })
      },

      async print () {
        try {
          const pdf = new JSPDF('landscape', 'mm')

          // Função para adicionar tabela e controlar quebra de página
          const addTable = async (data, headers, title, posY, fontSize) => {
            pdf.text(title, 20, posY)
            posY += pdf.getTextDimensions(title).h /* + 5 */

            pdf.autoTable({
              head: [headers.map(header => ({ content: header.text, styles: { fontSize: fontSize, textColor: [0, 0, 0], halign: header.text !== 'Conta Corrente' ? 'center' : 'left' } }))],
              body: this.contasBancarias.map(item => {
                return [
                  {
                    content: item.desc_conta,
                    styles: { fontSize: 8, textColor: [0, 0, 0], halign: 'left' },
                  },
                  {
                    content: item.saldo,
                    styles: { fontSize: 8, textColor: this.hexToRgbDetalhe(this.getColorImpressaoDetalhe(item.saldo)), halign: 'right' },
                  },
                ]
              }),
              startY: posY,
              styles: { fontSize: fontSize },
            })

            if (title !== 'Qual minha movimentação para os próximos 35 dias?') {
              await pdf.addPage()
            }

            posY = 20

            return posY
          }

          const addTableMovimentacaoValores = async (data, headers, title, posY, fontSize) => {
            pdf.text(title, 20, posY)
            posY += pdf.getTextDimensions(title).h

            pdf.autoTable({
              head: [headers.map(header => ({ content: header.text, styles: { fontSize: 10, textColor: [0, 0, 0], halign: header.text !== 'Conta' ? 'center' : 'left' } }))],
              body: this.dadosContas.map(item => {
                return [
                  {
                    content: item.conta,
                    styles: { fontSize: 8, textColor: [0, 0, 0], halign: 'left' },
                  },
                  {
                    content: item.valor1,
                    styles: { fontSize: 8, textColor: item.conta === 'Saldo' ? this.hexToRgbDetalhe(this.getColorImpressaoDetalhe(item.valor1)) : (item.conta === 'Receber' ? this.hexToRgbDetalhe('#4780b8') : this.hexToRgb('#f27686')), halign: 'right' },
                  },
                  {
                    content: item.valor2,
                    styles: { fontSize: 8, textColor: item.conta === 'Saldo' ? this.hexToRgbDetalhe(this.getColorImpressaoDetalhe(item.valor2)) : (item.conta === 'Receber' ? this.hexToRgbDetalhe('#4780b8') : this.hexToRgb('#f27686')), halign: 'right' },
                  },
                  {
                    content: item.valor3,
                    styles: { fontSize: 8, textColor: item.conta === 'Saldo' ? this.hexToRgbDetalhe(this.getColorImpressaoDetalhe(item.valor3)) : (item.conta === 'Receber' ? this.hexToRgbDetalhe('#4780b8') : this.hexToRgb('#f27686')), halign: 'right' },
                  },
                  {
                    content: item.valor4,
                    styles: { fontSize: 8, textColor: item.conta === 'Saldo' ? this.hexToRgbDetalhe(this.getColorImpressaoDetalhe(item.valor4)) : (item.conta === 'Receber' ? this.hexToRgbDetalhe('#4780b8') : this.hexToRgb('#f27686')), halign: 'right' },
                  },
                  {
                    content: item.valor5,
                    styles: { fontSize: 8, textColor: item.conta === 'Saldo' ? this.hexToRgbDetalhe(this.getColorImpressaoDetalhe(item.valor5)) : (item.conta === 'Receber' ? this.hexToRgbDetalhe('#4780b8') : this.hexToRgb('#f27686')), halign: 'right' },
                  },
                  {
                    content: item.valor6,
                    styles: { fontSize: 8, textColor: item.conta === 'Saldo' ? this.hexToRgbDetalhe(this.getColorImpressaoDetalhe(item.valor6)) : (item.conta === 'Receber' ? this.hexToRgbDetalhe('#4780b8') : this.hexToRgb('#f27686')), halign: 'right' },
                  },
                ]
              }),
              startY: posY,
              styles: { fontSize: 10 },
            })

            const endY = pdf.lastAutoTable.finalY
            const alturaTabela = endY - posY

            posY = alturaTabela + 30

            return posY
          }

          const addTableMovimentacao = async (data, headers, title, posY, fontSize) => {
            pdf.text(title, 20, posY)
            posY += pdf.getTextDimensions(title).h

            pdf.autoTable({
              head: [headers.map(header => ({ content: header.text, styles: { fontSize: 10, textColor: [0, 0, 0], halign: header.text !== 'Período' ? 'center' : 'left' } }))],
              body: this.dadosMovimentacao.map(item => {
                const colorSaldoInicial = this.getColorImpressao(item.saldo_inicial)
                const colorSaldoProjetado = this.getColorImpressao(item.saldo_projetado)

                return [
                  {
                    content: item.periodo,
                    styles: { fontSize: 8, textColor: [0, 0, 0], halign: 'left' },
                  },
                  {
                    content: item.saldo_inicial,
                    styles: { fontSize: 8, textColor: this.hexToRgb(colorSaldoInicial), halign: 'right' },
                  },
                  {
                    content: item.receber,
                    styles: { fontSize: 8, textColor: this.hexToRgb('#4780b8'), halign: 'right' },
                  },
                  {
                    content: item.pagar,
                    styles: { fontSize: 8, textColor: this.hexToRgb('#f27686'), halign: 'right' },
                  },
                  {
                    content: item.saldo_projetado,
                    styles: { fontSize: 8, textColor: this.hexToRgb(colorSaldoProjetado), halign: 'right' },
                  },
                ]
              }),
              startY: posY,
              styles: { fontSize: 10 },
            })

            posY = 20

            return posY
          }

          // Definir a margem esquerda
          let posYFiltros = 10
          const marginLeftRem = -1
          const marginLeftPx = marginLeftRem * 16

          // Adicionar saldo bancario
          const saldoTotal = document.getElementById('saldoTotalId')
          const canvas = await html2canvas(saldoTotal)
          const imgWidth = 180
          const imgHeight = (canvas.height * imgWidth) / canvas.width

          pdf.addImage(canvas.toDataURL('image/png'), 'PNG', 20 + marginLeftPx, posYFiltros, imgWidth, imgHeight)
          posYFiltros += imgHeight/*  + 5 */

          // Adicionar a tabela "Quais meus clientes que não compraram no mês?"
          const titleTableSaldo = 'Qual seu saldo bancário disponível?'
          const tableSaldoBancario = this.contasBancarias.map(item => [item.desc_conta, item.saldo])
          posYFiltros = await addTable(tableSaldoBancario, this.headersContaBancaria, titleTableSaldo, posYFiltros, 8)

          // Adiciona projeção financeira
          const projecaoFinanceira = document.getElementById('projecaoFinanceira')
          const canvasProjecaoFinanceira = await html2canvas(projecaoFinanceira)
          const imgWidthProjecaoFinanceira = 210
          const imgHeightProjecaoFInanceira = (canvasProjecaoFinanceira.height * imgWidthProjecaoFinanceira) / canvasProjecaoFinanceira.width

          pdf.addImage(canvasProjecaoFinanceira.toDataURL('image/png'), 'PNG', 70 + marginLeftPx, posYFiltros, imgWidthProjecaoFinanceira, imgHeightProjecaoFInanceira)
          posYFiltros += imgHeightProjecaoFInanceira

          pdf.addPage()
          posYFiltros = 20

          const titleMovimentacao = 'Movimentação dos Valores à receber, pagar e saldo? '
          const tableMovimentacao = this.dadosContas.map(item => [item.conta, item.valor1, item.valor2, item.valor3, item.valor4, item.valor4, item.valor6])
          posYFiltros = await addTableMovimentacaoValores(tableMovimentacao, this.headerDetalhamentoSaldo, titleMovimentacao, posYFiltros, 8)

          posYFiltros += 10

          const titleTableMovimentacao = 'Qual minha movimentação para os próximos 35 dias?'
          const tableTableMovimentacao = this.dadosMovimentacao.map(item => [item.periodo, item.saldo_inicial, item.receber, item.pagar, item.saldo_projetado])
          posYFiltros = await addTableMovimentacao(tableTableMovimentacao, this.headersMovimentacao, titleTableMovimentacao, posYFiltros, 8)

          // Salvar o PDF
          pdf.save('relatorio_fluxo_caixa.pdf')
        } catch (error) {
          console.error('Erro ao gerar PDF:', error)
        } finally {
          this.loadingPrint = false
          this.loadingBtnPrint = true
          this.enableTextoSaldo = false
        }
      },

      hexToRgb (hex) {
        const bigint = parseInt(hex.replace('#', ''), 16)
        return [(bigint >> 16) & 255, (bigint >> 8) & 255, bigint & 255]
      },

      getColorImpressao (value) {
        var negativo = value.substr(0, 1)

        return negativo === '-' ? '#f27686' : '#4CAF50'
      },

      showSnackbar (color, timeout, message) {
        this.snackbar.message = message
        this.snackbar.color = color
        this.snackbar.visible = true
        this.snackbar.timeout = timeout
      },

      async imprimirDetalhe (titulo, urlImpressao) {
        try {
          this.loadingPrint = true
          this.imprimindo = true

          await this.executarImpressaoDetalhe(titulo, urlImpressao)
        } catch (error) {
          console.error('Erro ao imprimir:', error)
        } finally {
          this.loadingPrint = false
          this.imprimindo = false
        }
      },

      async executarImpressaoDetalhe (titulo, urlImpressao) {
        return new Promise(resolve => {
          setTimeout(() => {
            this.printDetalhe(10, titulo, urlImpressao)

            resolve()
          }, 3000)
        })
      },

      async printDetalhe (posYFiltros, titulo, urlImpressao) {
        try {
          const pdf = new JSPDF('landscape', 'mm')

          // Função para adicionar tabela e controlar quebra de página
          const addTable = async (data, headers, title, posY, fontSize) => {
            pdf.text(title, 20, posY)
            posY += pdf.getTextDimensions(title).h

            pdf.autoTable({
              head: [headers.map(header => ({ content: header.text, styles: { fontSize: 10, textColor: [0, 0, 0], halign: header.text === 'Valor' ? 'right' : 'left' } }))],
              body: this.dadosDetalhamento.map(item => {
                return [
                  {
                    content: item.data,
                    styles: { fontSize: 8, textColor: [0, 0, 0], halign: 'left' },
                  },
                  {
                    content: item.cliente,
                    styles: { fontSize: 8, textColor: [0, 0, 0], halign: 'left' },
                  },
                  {
                    content: item.valor,
                    styles: { fontSize: 8, textColor: item.carteira === 'R' ? this.hexToRgbDetalhe('#4780b8') : this.hexToRgb('#f27686'), halign: 'right' },
                  },
                ]
              }),
              startY: posY,
              styles: { fontSize: 10 },
            })

            posY = 20

            return posY
          }

          const titleTableMovimentacao = titulo

          const tableTableMovimentacao = this.dadosDetalhamento.map(item => [item.data, item.cliente, item.valor])

          await addTable(tableTableMovimentacao, this.headersDetalhe, titleTableMovimentacao, posYFiltros, 8)

          // Salvar o PDF
          pdf.save(urlImpressao)
        } catch (error) {
          console.error('Erro ao gerar PDF:', error)
        } finally {
          this.loadingPrint = false
        }
      },

      async onClickReceber (item) {
        this.headersDetalhe = [
          { text: 'Data', value: 'data', class: 'black--text title' },
          { text: 'Cliente', value: 'nome', class: 'black--text title' },
          { text: 'Valor', value: 'valor', align: 'right', class: 'black--text title' },
        ]

        this.dadosDetalhamento = []

        await FluxoCaixa.showDadosDelhamentoDataValoresAReceber(item.data, 'R', localStorage.tokencontrato, this.select).then(resposta => {
          if (resposta.data.status) {
            this.dadosDetalhamento = resposta.data.dadosMovimentacao.map((item) => {
              var listaDetalhamento = ({
                data: item.data,
                cliente: item.nome,
                valor: parseFloat(item.valor).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
                carteira: 'R',
              })

              return listaDetalhamento
            })

            this.showDialog('Dados Detalhe Recebimento', 'relatorio_detalhe_recebimento')
          } else if (resposta.data.msg === 'Não há dados para detalhamento no período selecionado') {
            this.dadosDetalhamento = []

            this.showSnackbar('error', 3000, resposta.data.msg)
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        })
      },

      async onClickPagamento (item) {
        this.headersDetalhe = [
          { text: 'Data', value: 'data', class: 'black--text title' },
          { text: 'Fornecedor', value: 'nome', class: 'black--text title' },
          { text: 'Valor', value: 'valor', align: 'right', class: 'black--text title' },
        ]

        this.dadosDetalhamento = []

        await FluxoCaixa.showDadosDelhamentoDataValoresAReceber(item.data, 'P', localStorage.tokencontrato, this.select).then(resposta => {
          if (resposta.data.status) {
            this.dadosDetalhamento = resposta.data.dadosMovimentacao.map((item) => {
              var listaDetalhamento = ({
                data: item.data,
                cliente: item.nome,
                valor: parseFloat(item.valor).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
                carteira: 'P',
              })

              return listaDetalhamento
            })

            this.showDialog('Dados Detalhe Recebimento', 'relatorio_detalhe_pagamento')
          } else if (resposta.data.msg === 'Não há dados para detalhamento no período selecionado') {
            this.detalheValores = []

            this.showSnackbar('error', 3000, resposta.data.msg)
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        })
      },

      async imprimirDetalheSaldo (titulo, urlImpressao) {
        try {
          this.loadingPrint = true
          this.imprimindo = true

          await this.executarImpressaoDetalheSaldo(titulo, urlImpressao)
        } catch (error) {
          console.error('Erro ao imprimir:', error)
        } finally {
          this.loadingPrint = false
          this.imprimindo = false
        }
      },

      async executarImpressaoDetalheSaldo (titulo, urlImpressao) {
        return new Promise(resolve => {
          setTimeout(() => {
            this.printDetalaheSaldo(10, titulo, urlImpressao)

            resolve()
          }, 3000)
        })
      },

      async printDetalaheSaldo (posYFiltros, titulo, urlImpressao) {
        try {
          const pdf = new JSPDF('landscape', 'mm')

          // Função para adicionar tabela e controlar quebra de página
          const addTable = async (data, headers, title, posY, fontSize) => {
            pdf.text(title, 20, posY)
            posY += pdf.getTextDimensions(title).h

            pdf.autoTable({
              head: [headers.map(header => ({ content: header.text, styles: { fontSize: 10, textColor: [0, 0, 0], halign: 'center' } }))],
              body: this.dadosDetalhamentoSaldo.map(item => {
                const colorSaldo = this.getColorImpressaoDetalheSaldo(item.saldo)

                return [
                  {
                    content: item.data,
                    styles: { fontSize: 8, textColor: [0, 0, 0], halign: 'left' },
                  },
                  {
                    content: item.receber,
                    styles: { fontSize: 8, textColor: this.hexToRgbDetalhe('#4780b8'), halign: 'right' },
                  },
                  {
                    content: item.pagamento,
                    styles: { fontSize: 8, textColor: this.hexToRgbDetalhe('#f27686'), halign: 'right' },
                  },
                  {
                    content: item.saldoExibicao,
                    styles: { fontSize: 8, textColor: this.hexToRgbDetalhe(colorSaldo), halign: 'right' },
                  },
                ]
              }),
              startY: posY,
              styles: { fontSize: 10 },
            })

            posY = 20

            return posY
          }

          const titleTableMovimentacao = titulo

          const tableTableMovimentacao = this.dadosDetalhamentoSaldo.map(item => [item.data, item.receber, item.pagamento, item.saldoExibicao, item.saldo])

          await addTable(tableTableMovimentacao, this.headersDetalheSaldo, titleTableMovimentacao, posYFiltros, 8)

          // Salvar o PDF
          pdf.save(urlImpressao)
        } catch (error) {
          console.error('Erro ao gerar PDF:', error)
        } finally {
          this.loadingPrint = false
        }
      },

      hexToRgbDetalhe (hex) {
        const bigint = parseInt(hex.replace('#', ''), 16)
        return [(bigint >> 16) & 255, (bigint >> 8) & 255, bigint & 255]
      },

      getColorImpressaoDetalhe (value) {
        var negativo = value.substr(0, 1)

        return negativo === '-' ? '#f27686' : '#4CAF50'
      },

      getColorImpressaoDetalheSaldo (value) {
        return value < 0 ? '#f27686' : '#4CAF50'
      },
    },
  }
</script>

<style scoped>
  #cardDashbord {
    border-radius: 14px;
    border: 1px solid rgba(0,0,0,0.05);
    box-shadow:
      0 2px 4px rgba(0,0,0,0.08),
      0 6px 12px rgba(0,0,0,0.06),
      0 12px 24px rgba(0,0,0,0.04);
    transition: all 0.25s ease;
    transform: translateY(-3px);
    box-shadow:
      0 4px 8px rgba(0,0,0,0.10),
      0 12px 22px rgba(0,0,0,0.09),
      0 20px 32px rgba(0,0,0,0.06);
  }

  .card-header-dashbord {
    background-color: #ffffff;
    padding: 14px 18px;
    font-weight: 600;
    font-size: 14px;
    color: black;
    border-bottom: 1px solid #b7b1b1;
    border-radius: 14px 14px 0 0;
  }

  #idTable {
    overflow-x: auto;
    overflow-y: auto;
    width: 100%;
    max-width: 100vw;
  }

  table {
    width: 100%;
    border-collapse: collapse;
    font-family: Roboto, sans-serif;
    border: 1px solid #e0e0e0;
  }

  th, td {
    border: 1px solid #e0e0e0;
    padding: 10px;
    color: #424242;
  }

  thead {
    background-color: #f5f5f5;
  }

  thead th {
    position: sticky;
    top: 0;
    z-index: 2;
    background-color: #f5f5f5;
  }

  tbody tr:hover {
    background-color: #f0f0f0;
  }

  #dadoMovimentacaoHeader {
    font-size: 12px !important;
    font-weight: 800 !important;
  }

  @media screen
  and (min-device-width : 320px)
  and (max-device-width : 680px) {
    #painelfluxocaixa2 {
      margin: 0 0 0 -1rem;
    }

    #idMovimentacaoFinanceira {
      margin: 0 0 0 -1rem;
      width: 125%;
    }

    #idMovimentacaoValores {
      margin: 0 0 0 0rem;
    }

    .container {
      display: flex;
      flex-wrap: wrap;
    }

    .cell {
      display: flex;
      align-items: center;
      height: 100px;
    }

    #saldoBancario {
      max-width: 97%;
    }

    #movimentacaoFinanceira {
      max-width: 93%;
    }

    #movimentacaoFinanceiraValores {
      max-width: 93%;
    }

    #idTable {
      width: 90%;
    }

    table {
      width: auto;
    }

    th, td {
      /* padding: 8px; */
      white-space: nowrap !important;
    }

    #dadoMovimentacao {
      font-size: 8.5px;
    }

    #dadoMovimentacaoDetalhe {
      font-size: 8.5px;
    }
  }

  @media screen
  and (min-width : 681px)
  and (max-width : 960px)
  and (-webkit-min-device-pixel-ratio: 1) {
  }
</style>

<style lang="sass">
  #dadoMovimentacao
    font-size: 14px
    font-weight: bold
    text-align: right

  .container
    max-width: 100%

  .highlighted-item
    background-color: #2863af
    padding: 16px
    color: white
    margin: -1rem 0 0 0

  #listItemFluxoCaixa
    margin: -2rem 0 0 -1rem

  #movimentacaoFinanceira
    margin: -2rem 0 0 0

  #movimentacaoFinanceiraValores
    margin: -2rem 0 0 0

  #listItemMovimentacao
    margin: -2rem 0 0 -1rem

  #textoSaldo
    margin: 0 0 -2rem 31rem
    font-size: 33px

</style>
